import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from "@angular/http";
import { Routes, RouterModule } from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatButtonModule} from '@angular/material';
import {MatDialogModule} from '@angular/material';
import {MatDialog, MatDialogRef} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material';

import { AppComponent } from './app.component';
import { routing, appRoutingProviders  } from './app.routing';
//Services
import { AuthGuard } from './service/auth-guard.service';
import { AuthService } from './service/auth.service';
import { DialogsService } from './service/dialogs.service';
import {UserRegistrationService} from "./service/user-registration.service";
import {UserParametersService} from "./service/user-parameters.service";
import {UserLoginService} from "./service/user-login.service";
import {CognitoUtilService} from "./service/cognito-util.service";
import {AwsUtilService} from "./service/aws-util.service";
import { GlobalEventsManagerService } from './service/global-events-manager.service';
import { S3Service } from './service/s3.service';
import { FlexLayoutModule } from '@angular/flex-layout';
//Components
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { RegisterComponent } from './public/auth/register/register.component';
import { LoginComponent } from './public/auth/login/login.component';
import { NewPasswordComponent } from './public/auth/new-password/new-password.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NewsComponent } from './public/news/news.component';
import { ContactsComponent } from './public/contacts/contacts.component';
import { MemosComponent } from './memos/memos.component';
import { LogoutComponent } from './public/auth/logout/logout.component';
import { HomeComponent } from './public/home/home.component';
import { JwtComponent } from './secure/jwttokens/jwt.component';
import { SecureHomeComponent } from './secure/landing/securehome.component';
import { MyProfileComponent } from './secure/profile/myprofile.component';
import { UseractivityComponent } from './secure/useractivity/useractivity.component';
import { HttpErrorComponent } from './http-error/http-error.component';
import { RegistrationConfirmationComponent} from "./public/auth/confirm/confirmRegistration.component";
import { ForgotPasswordStep1Component} from "./public/auth/forgot/forgotPasswordStep1.component";
import { ForgotPasswordStep2Component } from "./public/auth/forgot/forgotPasswordStep2.component";
import { ForgotPasswordStep1DialogComponent } from './public/auth/forgot/forgotPasswordStep1Dialog.component';
import { ForgotPasswordStep2DialogComponent } from './public/auth/forgot/forgotPasswordStep2Dialog.component';

import { NewPasswordDialogComponent } from'./public/auth/login/newPasswordDialog.component';
import { DialogResultExampleDialogComponent } from './public/auth/login/dialog-result-example-dialog.component';
import { AddFolderDialogComponent } from './memos/addFolderDialog.component';
import { AddContactDialogComponent } from './public/contacts/addContactDialog.component';
import { AddNewsDialogComponent } from './public/news/addNewsDialog.component';

@NgModule({
  declarations: [
    AppComponent, RegisterComponent, LoginComponent,RegistrationConfirmationComponent,
    NewPasswordComponent, NavbarComponent, NewsComponent,AddNewsDialogComponent,NewPasswordDialogComponent,
    ContactsComponent, MemosComponent, LogoutComponent,AddContactDialogComponent,
    HomeComponent, DialogResultExampleDialogComponent,HttpErrorComponent,ConfirmDialogComponent,
    JwtComponent, SecureHomeComponent, MyProfileComponent,UseractivityComponent,ForgotPasswordStep1Component,
    ForgotPasswordStep2Component,ForgotPasswordStep1DialogComponent,ForgotPasswordStep2DialogComponent,AddFolderDialogComponent
  ],
  imports: [
    BrowserModule,BrowserAnimationsModule,MatInputModule,FlexLayoutModule,
    FormsModule, HttpModule, routing,MatIconModule,MatCardModule,MatFormFieldModule,ReactiveFormsModule,
    MatDialogModule ,MatButtonModule,MatGridListModule ,MatListModule,MatProgressBarModule

  ],
  entryComponents: [
    DialogResultExampleDialogComponent,ForgotPasswordStep1DialogComponent,AddContactDialogComponent,NewPasswordDialogComponent,
    ForgotPasswordStep2DialogComponent,AddFolderDialogComponent,ConfirmDialogComponent,AddNewsDialogComponent
  ],
  providers: [
    UserRegistrationService, UserParametersService, UserLoginService, HttpErrorComponent,DialogsService,AuthGuard,
    GlobalEventsManagerService, CognitoUtilService, AwsUtilService,appRoutingProviders,S3Service,AuthService,
    {provide: MAT_DIALOG_DATA, useValue: {} },
    {provide: MatDialogRef, useValue: {} }, 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts